export const getHumanRole = (role) => {
  switch (role) {
    case 20:
      return "observer"
    case 15:
      return "teacher"
    case 10:
      return "moderator"
    case 5:
      return "student"
  }
}

export const canInviteOrRemove = (role, permissions) => {
  switch (role) {
    case 20:
      return permissions != null ? permissions.can_invite_observer : undefined
    case 15:
      return permissions != null ? permissions.can_invite_teacher : undefined
    case 10:
      return permissions != null ? permissions.can_invite_moderator : undefined
    case 5:
      return permissions != null ? permissions.can_facilitate : undefined
  }
}

export const sortByRole = (members) => {
  return _.sortBy(members, ({ role }) => -role)
}
